import { combineReducers } from 'redux';
import Signin from "./slices/LoginSlice";
import commonFunctionSlice from './slices/commonFunctionSlice';
import roleRightsReducer from "./slices/roleRightsSlice";
import dashBoardReducer from "./slices/dashBoardSlice";


const rootReducer = combineReducers({
  signin: Signin,
  CommonFunction: commonFunctionSlice,
  roleRights: roleRightsReducer,
  dashboard: dashBoardReducer,
});

export default rootReducer;
